jQuery( document ).ajaxError(function(a, b, c, d) {
    if(b.status === 401 && jQuery('.whoops-page').length === 0) {
        window.location.href = "/login";
    }
});
